"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getType = void 0;
exports.getType = (value) => Object.prototype.toString.call(value);
//# sourceMappingURL=get-type.js.map